import { render } from "./ListeSuiviCommande.vue?vue&type=template&id=18e96b1a&ts=true"
import script from "./ListeSuiviCommande.vue?vue&type=script&lang=ts"
export * from "./ListeSuiviCommande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__